import {Component} from "javascripts/lib/component";
import {StoreLayout} from "javascripts/layouts/store_layout";

Component.load(StoreLayout);
